module.exports = __webpack_public_path__ + "static/media/banner_sky.2207b545.png";